import { create } from 'zustand';

interface AgentThought {
  id: string;
  agentName: string;
  thought: string;
  timestamp: string | number;
  type: 'thinking' | 'analyzing' | 'suggesting' | 'acting';
  conversationId?: string;
  confidence?: number;
  metadata?: any;
}

interface AgentState {
  activeAgents: string[];
  thoughts: AgentThought[];
  isProcessing: boolean;
  
  // Actions
  addThought: (thought: Omit<AgentThought, 'id' | 'timestamp'>) => void;
  registerAgent: (name: string) => void;
  unregisterAgent: (name: string) => void;
  clearThoughts: () => void;
}

export const useAgentStore = create<AgentState>((set) => ({
  activeAgents: [],
  thoughts: [],
  isProcessing: false,

  addThought: (thought) => set((state) => ({
    isProcessing: thought.type !== 'acting',
    thoughts: [
      {
        ...thought,
        id: Math.random().toString(36).substring(7),
        timestamp: Date.now(),
      },
      ...state.thoughts.slice(0, 49), // Mantém apenas os últimos 50 pensamentos
    ],
  })),

  registerAgent: (name) => set((state) => ({
    activeAgents: state.activeAgents.includes(name) 
      ? state.activeAgents 
      : [...state.activeAgents, name],
  })),

  unregisterAgent: (name) => set((state) => ({
    activeAgents: state.activeAgents.filter((a) => a !== name),
  })),

  clearThoughts: () => set({ thoughts: [] }),
}));
